import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { loginApi } from "../../api/authAPI";
import { profileApi } from "../../api/profileAPI";

const initialState = {
  user: null,
  loading: false,
};

// export const useAsyncLogout = false;

export const profileAsync = createAsyncThunk("profile", async () => {
  try {
    const response = await profileApi();
    // The value we return becomes the `fulfilled` action payload
    if (response) return response.data;
  } catch (err) {
    if (err.response.status === 404) {
      return;
    }
  }
});

// export const logoutAsync = createAsyncThunk("auth/logout", async () => {
//   const response = await logoutApi();
//   return response.data;
// });

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    // syncState: (state) => {
    //   state.user = getLocalStorage("user", null);
    //   state.isAuthenticated = getLocalStorage("isAuthenticated", false);
    // },
    // logout: (state) => {
    //   state.user = null;
    //   state.isAuthenticated = false;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(profileAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(profileAsync.fulfilled, (state, action) => {
        if (action.payload) {
          //   setLocalStorage("isAuthenticated", true);
          //   setLocalStorage("token", action.payload.user.token);
          //   state.isAuthenticated = true;
          state.user = action.payload.user;
        }
        state.loading = false;
      })
      .addCase(profileAsync.rejected, (state) => {
        state.loading = false;
      });
    // .addCase(logoutAsync.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(logoutAsync.fulfilled, (state, action) => {
    //   state.isAuthenticate = true;
    //   state.user = action.payload;
    //   localStorage.removeItem("user");
    //   localStorage.removeItem("isAuthenticate");
    //   state.loading = false;
    //   window.location.href = "/";
    // })
    // .addCase(logoutAsync.rejected, (state) => {
    //   state.loading = false;
    // });
  },
});

// export const selectAuth = (state) => state.auth;
// export const selectToken = (state) => state.auth.user?.token;
export const selectLoading = (state) => state.profile.loading;
// export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.profile.user;

// export const { syncState, logout } = authSlice.actions;
export default profileSlice.reducer;
